var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('v-autocomplete',{staticClass:"search-field row",attrs:{"items":_vm.employeePage.docs.filter(function (x) {
        if (x.user) {
          var u = x.user;
          u.eId = x._id;
          return u;
        }
      }),"item-text":"fullName","item-value":"user","height":"20","label":"Employee Filter"},model:{value:(_vm.employee),callback:function ($$v) {_vm.employee=$$v},expression:"employee"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }